var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec5Cardimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9566 28.8106L27.2736 32.1096C27.3624 32.198 27.5063 32.197 27.594 32.1073L35.0436 24.4863M24.8262 49.5673H36.3397C36.4643 49.5673 36.5653 49.4663 36.5653 49.3417V43.0902C36.5653 42.9656 36.4643 42.8646 36.3397 42.8646H34.174M24.8262 49.5673H22.4431C22.3185 49.5673 22.2175 49.4663 22.2175 49.3417V43.0902C22.2175 42.9656 22.3185 42.8646 22.4431 42.8646H23.9566M24.8262 49.5673C24.8262 56.9186 34.174 56.7024 34.174 49.5673M23.9566 42.8646C23.9566 42.8646 14.3523 35.4382 14.3914 28.8106C14.4404 20.5114 21.2652 13.7715 29.6088 13.8917C37.8324 14.0103 44.4194 20.6307 44.3914 28.8106C44.3683 35.5835 34.174 42.8646 34.174 42.8646M23.9566 42.8646H34.174M43.7391 42.8646L48.9565 48.0539M48.9565 28.8106H57M43.087 15.1891L48.9565 9.78375M29.6088 9.78375V2M15.6957 15.1891L10.2609 9.78375M10.2609 28.8106H2M15.6957 42.8646L10.2609 48.0539",
    stroke: "#102C57",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec5Cardimg1);
export default __webpack_public_path__ + "static/media/sec5cardimg1.fdfbcb728c228bc98cbe838d86b2b3a9.svg";
export { ForwardRef as ReactComponent };